export class OnboardingProduct {
    constructor(
        public productId: number,
        public name: string,
        public code: number,
        public accountType: string,
        public productType: string,
        public interestRate: number,
        public interestPlanCodes: number[],
        public olbGroupId: number,
        public brandName: string,
        ) { }
  }
